import { ConfirmationDialogAfterClosedModel } from '../../../../ui-kit';
import { ChangePasswordModel, ProfileModel } from './models';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthMeDto } from '../../auth';

export class ProfileLoad {
  public static readonly type = '[Profile] Load';
}

export class ProfileUpdate {
  public static readonly type = '[Profile] Update';

  constructor(public payload: ProfileModel) {}
}

export class ProfileChangePassword {
  public static readonly type = '[Profile] Change password';

  constructor(public payload: { body: ChangePasswordModel; dialogRef: MatDialogRef<unknown> }) {}
}

export class ProfileUpdatePassword {
  public static readonly type = '[Profile] Update password';

  constructor(public payload: { body: ChangePasswordModel }) {}
}

export class ProfileAcceptMapsPlugin {
  public static readonly type = '[Profile] Accept maps plugin';
}

export class ProfileDelete {
  public static readonly type = '[Profile] Delete';
  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel> }) {}
}

export class ProfileInitialState {
  public static readonly type = '[Profile] Set initial state';
}

export class ProfileSetFromAuthMe {
  public static readonly type = '[Profile] Set from /auth/me';
  constructor(public payload: AuthMeDto) {}
}
